// Core routes: dashboard-adjacent pages, profile, inbox, notifications, tasks
import Profile from '../pages/Profile';
import Inbox from '../pages/Inbox';
import NotificationsCenter from '../pages/NotificationsCenter';
import MyTasks from '../pages/MyTasks';
import ActionCenter from '../pages/ActionCenter';
import AIInsights from '../pages/AIInsights';
import InsightsDashboard from '../pages/InsightsDashboard';
import CommercialHub from '../pages/CommercialHub';
import DemoCenter from '../pages/DemoCenter';
import SmokeTest from '../pages/SmokeTest';
import Documents from '../pages/Documents';
import GovernanceAnalytics from '../pages/GovernanceAnalytics';

const coreRoutes = [
  { path: '/profile', Component: Profile },
  { path: '/inbox', Component: Inbox, withUser: true },
  { path: '/notifications', Component: NotificationsCenter, withUser: true },
  { path: '/my-tasks', Component: MyTasks, withUser: true },
  { path: '/cfo-actions', Component: ActionCenter },
  { path: '/ai-insights', Component: AIInsights },
  { path: '/insights', Component: InsightsDashboard },
  { path: '/commercial-hub', Component: CommercialHub },
  { path: '/admin/demo', Component: DemoCenter },
  { path: '/smoke-test', Component: SmokeTest },
  { path: '/documents', Component: Documents, withUser: true },
  // Patch 24.1 — Governance Analytics + Block Heatmap
  { path: '/governance-analytics', Component: GovernanceAnalytics },
];

export default coreRoutes;
